import { configureStore, combineReducers } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import uiReducer from './slices/uiSlice';
import authReducer from './slices/authSlice';
import constructionReducer from './slices/constructionSlice';

const persistConfig = {
    key: 'insanet',
    storage,
    whitelist: ['auth', 'ui'], // auth ve ui state'leri persist edilecek
};

const rootReducer = combineReducers({
    ui: uiReducer,
    auth: authReducer,
    construction: constructionReducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
            },
        }),
    devTools: import.meta.env.DEV,
});

export const persistor = persistStore(store);

export default store;
